/**
 * @generated SignedSource<<446f0601036eb5fae50e48e8b6fa7a88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type TeamScheduleInlineRoutineOccasionListItemMutation$variables = {
  employeeId?: string | null;
  taskExecutionId: string;
  value?: TaskSentiment | null;
};
export type TeamScheduleInlineRoutineOccasionListItemMutation$data = {
  readonly setTaskExecutionCheck: {
    readonly checkValue: TaskSentiment | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly routineOccasion: {
      readonly completedTaskExecutionCount: number | null;
      readonly status: RoutineOccasionStatus;
      readonly totalTaskExecutionCount: number | null;
    };
  };
};
export type TeamScheduleInlineRoutineOccasionListItemMutation$rawResponse = {
  readonly setTaskExecutionCheck: {
    readonly checkValue: TaskSentiment | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly routineOccasion: {
      readonly completedTaskExecutionCount: number | null;
      readonly id: string;
      readonly status: RoutineOccasionStatus;
      readonly totalTaskExecutionCount: number | null;
    };
  };
};
export type TeamScheduleInlineRoutineOccasionListItemMutation = {
  rawResponse: TeamScheduleInlineRoutineOccasionListItemMutation$rawResponse;
  response: TeamScheduleInlineRoutineOccasionListItemMutation$data;
  variables: TeamScheduleInlineRoutineOccasionListItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskExecutionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "taskExecutionId"
  },
  {
    "kind": "Variable",
    "name": "sentiment",
    "variableName": "value"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkValue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedTaskExecutionCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleInlineRoutineOccasionListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TaskExecutionCheck",
        "kind": "LinkedField",
        "name": "setTaskExecutionCheck",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineOccasion",
            "kind": "LinkedField",
            "name": "routineOccasion",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamScheduleInlineRoutineOccasionListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TaskExecutionCheck",
        "kind": "LinkedField",
        "name": "setTaskExecutionCheck",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineOccasion",
            "kind": "LinkedField",
            "name": "routineOccasion",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d25fd8e99f41fb3145510526a300ab64",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleInlineRoutineOccasionListItemMutation",
    "operationKind": "mutation",
    "text": "mutation TeamScheduleInlineRoutineOccasionListItemMutation(\n  $taskExecutionId: ID!\n  $employeeId: ID\n  $value: TaskSentiment\n) {\n  setTaskExecutionCheck(id: $taskExecutionId, employeeId: $employeeId, sentiment: $value) {\n    id\n    checkValue\n    isCompleted\n    routineOccasion {\n      completedTaskExecutionCount\n      totalTaskExecutionCount\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "917c3cf39633e118037a4a987a7dcb08";

export default node;
